
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/personal-data-processing",
      function () {
        return require("private-next-pages/[lang]/legal/personal-data-processing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/personal-data-processing"])
      });
    }
  